import style from '../Home.module.scss';
import {memo, useCallback, useEffect, useState} from "react";
import className from 'classnames/bind';
import {Col, Row, Tag} from "antd";
import {
    apiError,
    handleRequest,
} from "~/utils";

import {
    dashboardApi
} from "~/api";

import {
    ContentHeader,
    SidebarAccount
} from "../componets";
import {Image} from "../../../components";
import {numberFormat, renderDate} from "../../../utils";

const cn = className.bind(style);

function DashboardAccountingManager({user, fullTime}) {

    const [dashboardData, setDashboardData] = useState({
        website: [],
        host: [],
        extension: [],
    });

    useEffect(() => {
        fetchDashboardData().then()
    }, [user]);

    const fetchDashboardData = useCallback(async () => {
        const [
            contractRanksResponse,
        ] = await Promise.all([
            handleRequest(dashboardApi.contractRanks()),
        ]);

        //Xếp hạng
        let [revenueRankHighErr, revenueRankHighData] = contractRanksResponse;
        let revenueRankHighMsg = apiError(`Load danh sách sếp hạng thất bại`, revenueRankHighErr, revenueRankHighData);
        if (!revenueRankHighMsg) {
            setDashboardData({
                website: revenueRankHighData.data.website,
                host: revenueRankHighData.data.host,
                extension: revenueRankHighData.data.extension,
            });
        }
    }, [])

    const CardRanks = ({name, items, cardColor}) => {
        return (
            <div className={cn('card', 'card-contract-ranks', cardColor)}>
                <h4 className={cn('heading')}>{name}</h4>
                <div className={cn('list-ranks')}>
                    {
                        items.map((item) => {
                            return <div key={`card-rank-${item.id}`} className={cn('contract')}>
                                <b className={cn('name')}>{item.code} {item.name}</b>
                                <div className={cn('contract-info')}>
                                    <div className={cn('status')}>
                                        <Tag color={item.service.badge}>{item.service?.label}</Tag>
                                        <Tag color={item.service.badge}>{item.serviceType?.label}</Tag>
                                        {(item?.package) && <Tag color={item.service?.badge}>{item?.package}</Tag>}
                                    </div>
                                    <div><p>{renderDate(item?.signing)}</p></div>
                                    <p className={cn('price')}>{numberFormat(item.price)}</p>
                                </div>
                                <div className={cn('users-info')}>
                                    <div className={cn('user')}>
                                        <div className={cn('avatar-rank', 'avatar')}><Image src={item.user.avatar} /></div>
                                        <div className={cn('info')}>
                                            <b className={cn('name')}>{item.user.firstname} {item.user.lastname}</b>
                                            <p className={cn('info-more')}>{item.user.username}</p>
                                        </div>
                                    </div>
                                    <div className={cn('user')}>
                                        <div className={cn('avatar-rank', 'avatar')}><Image src={item?.userShare?.avatar} /></div>
                                        <div className="info">
                                            <b className={cn('name')}>{item?.userShare?.firstname} {item?.userShare?.lastname}</b>
                                            <p className={cn('info-more')}>{item?.userShare?.username}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
        )
    }

    return (
        <div className={cn('dashboard')}>
            <div className={cn('sidebar')}>
                <SidebarAccount user={user} />
            </div>
            <div className={cn('content')}>
                <ContentHeader user={user} fullTime={fullTime} />
                <Row gutter={20}>
                    <Col span={8}>
                        <CardRanks
                            name={'Hợp đồng website'}
                            items={dashboardData.website}
                            cardColor={'card-green'}
                        />
                    </Col>
                    <Col span={8}>
                        <CardRanks
                            name={'Hợp đồng host'}
                            items={dashboardData.host}
                            cardColor={'card-red'}
                        />
                    </Col>
                    <Col span={8}>
                        <CardRanks
                            name={'Hợp đồng gia hạn'}
                            items={dashboardData.extension}
                            cardColor={'card-yellow'}
                        />
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default memo(DashboardAccountingManager);
